import React, { } from 'react'
import DefaultObservationList from './DefaultObservationList';
import Sections from './46/Sections';
import ObservationList61 from './61/ObservationList';

const ObservationList = (props) => {
  return (
    <>
      {parseInt(process.env.REACT_APP_PROJECTID) === 46 ? <Sections {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 56 ? <DefaultObservationList {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 57 ? <DefaultObservationList {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 58 ? <DefaultObservationList {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 61 ? <ObservationList61 {...props} /> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 62 ? <DefaultObservationList {...props} /> : null }
    </>
  )
}

export default ObservationList